// Importing countries
import { COUNTRIES_FR } from './countries';

export const LANG_FR_CODE = 'fr-FR';
export const LANG_FR_NAME = 'Fra';
export const LANG_FR_COMPLETE_NAME = 'Français';
// ==== SUPPORTED LANGUAGES ====
// =============================
const LANG_FR = {
  'en-US': 'English',
  'es-ES': 'Español',
  'da-DA': 'Dansk',
  'fr-FR': 'Français',
  'fr-CA': 'Français (Canada)',
  'de-DE': 'Deutsch',
  'nl-NL': 'Nederlands',
  'ENGLISH': 'English',
  'SPANISH': 'Español',
  'DANISH': 'Dansk',
  'FRENCH': 'Français',
  'CANADIAN FRENCH': 'Français (Canada)',
  'GERMAN': 'Deutsch',
  'DUTCH': 'Nederlands',
  'MORE_INFO': 'info',
  // =========== LOGIN ===========
  // =============================
  'HOME': {
    'TITLE': 'Group Knowledge is Power',
    'TEXT': 'Concept Systems Incorporated brings organizations working on any collaborative initiative superior processes for capturing group wisdom from different points of view.'
  },
  'AUTO_LOGOUT': {
    'WARNING': {
      'TITLE': 'Toujours là?',
      'BUTTON': 'Continuez à travailler',
      'MESSAGE': 'Pour des questions de sécurité, nous vous déconnecterons après',
      'SECONDS': 'secondes',
    }
  },
  'LOGIN': {
    'USERNAME': 'Nom d\'utilisateur ',
    'USERNAME_OR_EMAIL': 'NOM D\'UTILISATEUR OU E-MAIL',
    'OR': 'ou',
    'ACTIVATE_ACCOUNT': 'Activez votre compte',
    'ACTIVATE_ACCOUNT_TEXT': 'Créez un compte et commencez à participer à des recherches importantes tout en vous amusant!',
    'ASSIGNED_USERNAME': 'NOM D\'UTILISATEUR ATTRIBUÉ',
    'YOUR_USERNAME': 'VOTRE NOM D\'UTILISATEUR',
    'ANONYMOUS_ACCOUNT': 'Compte anonyme',
    'DIFFERENT_EMAIL': 'Je veux utiliser un autre e-mail ',
    'PASSWORD': 'MOT DE PASSE',
    'FORGOT_PASSWORD': 'Vous avez oublié votre mot de passe?',
    'LOCKED_ACCOUNT': '*Votre compte a été bloqué. Veuillez contacter l\'Équipe d\'Assistance au Projet',
    'INVALID_USER': 'Nom d\'utilisateur ou mot de passe incorrect. Veuillez réessayer ou contacter l\'Équipe d\'Assistance au Projet',
    'WRONG_PASSWORD_1': 'Mot de passe incorrect! Il vous reste une seule tentative',
    'WRONG_PASSWORD': 'Mot de passe incorrect! Vous avez',
    'MORE_TRIES': 'Plusieurs tentatives',
    'RESET_PASSWORD': 'Réinitialiser le mot de passe',
    'DONE': 'Terminé',
    'INVITE_PROMPT': 'Vous avez été invité à participer à un nouveau projet',
    'INVITE_PROCEED': 'passer au projet',
    'HAVE_ACCOUNT': 'Vous avez déjà un compte?',
    'ASSIGNED_ACCOUNT': 'Si vous avez un nom d\'utilisateur et un mot de passe ASSIGNÉS,',
    'ASSIGNED_LINK': 'CLIQUEZ ICI',
    'LOGIN_HERE': 'Connectez-vous ici',
    'RESET_EXPIRE': 'Votre lien de réinitialisation est expiré. Veuillez faire une autre demande ci-dessous pour réinitialiser votre mot de passe',
    'RESEND': 'Renvoyer',
    'PWD_CONFIRMATION': 'Confirmation du nouveau mot de passe',
    'PDW_CHANGE_SUCCESSFULLY': 'Votre mot de passe a bien été modifié    ',
    'CONTINUE': 'CONTINUER',
    'CREATE_PASSWORD': 'Créez un mot de passee',
    'CREATE_ACCOUNT': 'Créez un compte',
    'CP_SUBTITLE': 'Créez un mot de passe pour votre compte anonyme',
    'CP_SUBTITLE_USERNAME': 'Créez un mot de passe pour le nom d\'utilisateur qui vous est assigné',
    'CP_SUBTITLE_EMAIL': 'Créez un mot de passe pour votre e-mail',
    'ANONYMOUS_SUGGESTION_TEXT': 'Nous vous recommandons fortement de prendre note de ceci',
    'WHY': 'Pourquoi?',
    'CONFIRM_PASSWORD': 'CONFIRMER VOTRE MOT DE PASSE',
    'LOG_IN': 'Connectez-vous',
    'FINISH_SU_ACCOUNT': 'Terminez de créez votre compte',
    'EMAIL': 'E-MAIL',
    'CHECK_INBOX': 'Consultez vos e-mails',
    'EMAIL_TEXT_NOTIFICATION': 'Nous avons envoyé un email à',
    'EMAIL_TEXT_NOTIFICATION_2': 'Avec un lien pour activer votre compte',
    'CLICK_LINK': 'Cliquez sur le lien et c\'est fait!',
    'BACK_LOGIN': 'Retour à la connection',
    'SEND_EMAIL_TEXT_NOTIFICATION': 'Nous vous enverrons un e-mail avec des instructions pour pouvoir réinitialiser votre mot de passe à l\'adresse suivante:',
    'FP_EMAIL_TEXT_NOTIFICATION': 'Un e-mail est en cours! Vous devriez recevoir des instructions pour pouvoir réinitialiser votre mot de passe au plus vite, soyez sûr de consulter votre spam (au cas où)',
    'DIDNT_GET_EMAIL': 'Vous n\'avez pas reçu l\'e-mail?',
    'RESEND_LINK': 'Renvoyez-moi le lien',
    'RESET_PASSWORD_SUCCESS': 'Veuillez contacter votre équipe de projet pour réinitialiser votre mot de passe',
    'NO_ACTIVITIES': {
      'OOPS': 'Oups!',
      'TEXT_MAIN': 'On dirait que ce projet a atteint le nombre de collaborateur nécessaire. Vous pouvez <a href="mailto:support@conceptsystems.com">contacter l\'administrateur du projet</a> si vous avez des questions!',
      'TEXT_NO_ACTIVITIES': 'Il n\'y a pas d\'activité ouverte pour ce lien d\'invitation au projet en ce moment. Vous pouvez contacter l\'administrateur du projet si vous avez des questions.',
    },
    'INFO_REGISTER_IDENTIFIER': 'Les administrateurs de projet pourront vous envoyer un e-mail par le système en fonction de l\'état de votre participation, mais ne pourront par voir votre adresse e-mail pour le relier à votre identifiant',
    'BROKEN_LINK': {
      'INFORMATION': 'Information:',
      'PROJECT_CONTACT': 'Personne de Contact du Projet:',
      'CAUSE': 'Le lien que vous utilisez ne marche pas - veuillez retrouver le lien initial et réessayer',
      'TEXT': 'Vous pouvez contacter l\'administrateur de projet si vous avez des questions!',
    },
    'CERATE_ACCOUNT': 'CRÉER UN COMPTE',
    'CREATE_ACCOUNT_IDENTIFIER': {
      'TITLE_CREATE': 'créez un compte',
      'TITLE_START': 'et commencez à apporter des idées',
      'STUDENT_ID': 'IDENTIFIANT DE L\'ÉLÈVE',
      'EMAIL': 'E-MAIL',
      'EMAIL_INFO': 'Votre e-mail ne sera pas visible à l\'équipe de projet',
      'CREATE_A_PASSWORD': 'CRÉER UN MOT DE PASSE',
      'STRONG': 'Robuste',
      'WEAK': 'Faible',
      'INVALID_USERNAME': 'Nom d\'utilisateur incorrect, réessayez',
      'INCOMPLETE_USERNAME': 'Vous devez saisir un nom d\'utilisateur',
      'USERNAME': 'Nom d\'utilisateur',
      'CHARACTERS_MINIMUM': 'Votre mot de passe doit contenir au moins 6 caractères',
      'SAME_USERNAME': 'Votre mot de passe ne peut pas être le même que votre nom d\'utilisateur',
      'MISSING_DIGIT': 'Votre mot de passe doit contenir au moins un chiffre',
      'MISSING_UPPERCASE': 'Votre mot de passe doit contenir au moins une majuscule',
      'MISSING_LOWERCASE': 'Votre mot de passe doit contenir au moins une minuscule',
      'MISSING_SYMBOL': 'Votre mot de passe doit contenir au moins un caractère non alphabétique',
      'PASSWORD_MAX': 'Vous devez saisir un mot de passe',
      'PASSWORD_PLACEHOLDER': 'Saisissez votre mot de passe',
      'SECURE_PASSWORD': 'Un mot de passe sécurisé devrait comprendre au moins:',
      'BASE_DIGIT': 'Un chiffre (entre 0 et 9)',
      'UPPERCASE_CHARACTER': 'Une lettre majuscule (de a à z)',
      'LOWERCASE_CHARACTER': 'Une lettre minuscule (de a à z)',
      'ALPHABETIC_CHARACTER': 'Un caractère non alphabétique (par exemple, !, $, %, #)',
      'MUST_PASSWORD_AGAIN': 'Vous devez resaisir votre mot de passe',
      'PASSWORD_NOT_MATCH': 'Les mots de passe ne correspondent pas',
      'PASSWORD_AGAIN': 'Resaisissez votre mot de passe',
    }
  },
  // ========= AUTOSAVE ==========
  // =============================
  'SAVING_STATUS': {
    'SAVED': 'Les modifications ont été mises à jour',
    'SAVING': 'mise à jour',
  },
  // ==== MY PROJECTS ===========
  // ============================
  'MY_PROJECTS': {
    'TITLE': 'Mes Projets',
    'TEXT': 'Cliquez sur un projet pour terminer les activités qui vous sont assignées.',
    'NO_PROJECT': {
      'TITLE': 'Oups!',
      'TEXT': 'Aucune activité ouverte de projet vous est assignée',
    }
  },
  // ==== SYSTEM ERROR ===========
  // ============================
  'SYSTEM_ERROR': {
    'TITLE': 'erreur de système inattendue',
    'MESSAGE': {
      'TITLE': 'Oups!',
      'TEXT': 'Une erreur de système inattendue a eu lieu. Veuillez réessayer dans quelques minutes. Si l\'erreur se reproduit, contactez',
      'EMAIL': 'assistance@conceptsystems.com',
    }
  },
  // ==== MY ACCOUNT ===========
  // ============================
  'MY_ACCOUNT': {
    'TITLE': 'Mon Compte',
    'INFORMATION': 'Données du Compte',
    'USERNAME': 'Nom d\'utilisateur',
    'EMAIL': 'E-mail',
    'PERSONAL_DETAILS': 'Données Personnelles',
    'FIRST_NAME': 'PRÉNOM',
    'EDIT': 'Modification',
    'SAVE': 'Mise à jour',
    'LAST_NAME': 'NOM DE FAMILLE',
    'CHANGE_PASSWORD': 'Modifier le mot de passe',
    'DONT_SEND_EMAIL': 'Ne m\'envoyez pas d\'emails de GroupWisdom<sup>tm</sup>',
    'CURRENT_PASSWORD': 'Mot de passe actuel',
    'NEW_PASSWORD': 'Nouveau mot de passe',
    'CONFIRM_PASSWORD': 'Validez le mot de passe',
    'CHANGED': 'Modifié',
    'ANONYMOUS_ACCOUNT': 'Compte anonyme',
    'TERMS': {
      'SHOW': 'Montrer',
      'LABEL': 'Conditions de groupwisdom<sup>tm</sup>',
    },
    'PRIVACY': {
      'SHOW': 'Montrer',
      'LABEL': 'Confidentialité de groupwisdom<sup>tm</sup>',
    },
    'ANONYMOUS_TOOLTIP': 'Pour les comptes anonymes, votre identité n\'est pas révélée à l\'équipe de projet',
  },
  // ==== HEADER  =================
  // =============================
  'HEADER': {
    'MY_PROJECTS': 'Projets',
    'MY_ACCOUNT': 'Compte',
    'NOTIFICATIONS': 'Notifications',
    'HELP_AND_SUPPORT': 'Aide et Assistance',
    'SIGN_OUT': 'Déconnecter',
    'CHOSE_LANGUAGE': 'Choisir une langue',
  },
  // ==== FOOTER =================
  // =============================
  'FOOTER': {
    'ITEMS': {
      'PRIVACY': 'Confidentialité',
      'TERMS': 'Conditions',
      'HELP': 'Aide et Assistance',
    },
    'COPYRIGHT': 'Copyright © 2000-2023. Tous droits réservés. Réalisation ',
    'COPYRIGHT_STRING': 'Concept Systems, In',
  },
  // ==== NOTIFICATIONS =================
  // =============================
  'NOTIFICATIONS': {
    'TITLE' : 'NOTIFICATIONS',
    'TITLE_NO' : 'PAS DE NOUVELLES NOTIFICATIONS',
    'TITLE_SINGLE' : 'UNE NOUVELLE NOTIFICATION',
    'TITLE_MULTIPLE' : 'NOUVELLES NOTIFICATIONS',
    'ALL': 'TOUTES LES NOTIFICATIONS',
    'PAGER': {
      'SHOWING': 'PRÉSENTATION',
      'TO' : 'À',
    },
    'NOTIFICATION': 'Notification',
    'FROM': 'De:',
  },
  // ==== INFORMED CONSENT MODAL ===========
  // =======================================
  'INFORMED_CONSENT_MODAL': {
    'TITLE': 'Consentement à participer',
    'DOWNLOAD': 'Télécharger le formulaire de consentement',
    'UPLOAD': 'Télécharger le formulaire de consentement signé',
    'TOOLTIP': 'Signez le formulaire de consentement et téléchargez-le pour continuer à participer au projet',
    'ACCEPT': 'ACCEPTER',
    'DECLINE': 'REFUSER',
    'FILE_ERROR': {
      'TYPE': 'Le consentement à participer doit être téléchargé en .pdf, .doc, .docx.',
      'SIZE': 'La limite des fichiers est de 10MB, réessayez',
    },
    'NO_DATA': 'Les données du consentement à participer n\'ont pas été fourni',
  },
  // ==== THANK YOU MODAL ===========
  // =======================================
  'THANK_YOU_MODAL': {
    'BUTTON_LINK': 'SUIVANT',
  },
  // ==== DECLINE INFORMED CONSENT MODAL ========
  // ============================================
  'DECLINE_ICM': {
    'TITLE': 'Vous avez refusé',
    'TEXT': 'Vous ne pouvez pas passer aux activités du projet sans avoir accepté le consentement à participer',
    'TEXT_1': 'Veuillez contacter l\'Équipe de Projet si vous avez des questions.',
    'CONTINUE': 'CONTINUER',
    'SING_OUT': 'Déconnecter',
  },
  // ====== PROJECT ===========================
  // ==========================================
  'PROJECT': {
    'SHOW_PI': 'Montrer les informations du projet',
    'VIEW_IC': 'Voir le consentement à participer',
    'AVAILABLE_ACTIVITIES': 'VOS ACTIVITÉS DISPONIBLES',
    'AVAILABLE_ACTIVITIES_TOOLTIP': 'Appuyez ou sélectionnez les boites d\'activité ouvertes, commencées, ou complétées pour accéder et modifier les  éléments dans cette activité. Lorsqu\'une activité n\'a pas encore été saisi, vous la verrez ouverte. Lorsqu\'une activité a été saisi, vous la verrez commencée jusqu\'à qu\'elle soit terminée. Complétée apparaitera lorsque tous les éléments de l\'activité seront complétés ou lorsque vous aurez sélectionné terminée.',
    'PROJECT_INFO_MODAL': {
      'TITLE': 'Coordonnées de la personne à contacter pour ce projet',
      'PHONE': 'Numéro de téléphone:',
      'EMAIL': 'E-mail:',
      'NO_DATA': 'Ce projet n\'a pas les coordonnées de la personne à contacter',
    },
    'PREVIEW': {
      'EXIT_TITLE': 'Vous prévisualisez ceci en tant que participant',
      'EXIT_BUTTON': 'Quitter l\'écran de prévisualisation',
    },
    'NO_ACTIVITIES': {
      'OOPS': 'Oups!',
      'TEXT_MAIN': 'On dirait que ce projet a atteint le nombre nécessaire de collaborateur. Vous pouvez contacter l\'administrateur du projet si vous avez des questions!',
      'TEXT': 'Vous n\'avez pas d\'activité qui vous est assignée',
    },
    'BRAINSTORMING': 'Brainstorming',
    'SORTING': 'Triage',
    'RATING': 'Évaluation',
    'PQ': 'Questions des participants',
    'CLOSES': 'Fermer',
  },
  // ==== BRAINSTORMING ========
  // ============================================
  'BRAINSTORMING': {
    'TITLE': 'Brainstorming',
    'INFO': 'Informations',
    'INFORMATION': 'Pensez soigneusement à vos idées. Vous pouvez ajouter plusieurs pensées ou idées de domaines et expériences différents en rapport avec les questions de discussion.',
    'ADD_IDEAS': 'Ajouter des idées',
    'COLLECTED_STATEMENTS': 'Les propos collectées',
    'COLLECTED_STATEMENTS_TOOLTIP': 'Il y a des propos collectées de tous les collaborateurs du brainstorming. La liste des données s\'actualise chaque fois que vous appuyez sur Rafraîchir la liste. ',
    'REFRESH': 'Rafraîchir la liste',
    'FINISH': 'Terminer',
    'STATEMENTS': {
      'ADD': 'Ajouter des propos',
      'NEW_STATEMENT_PLACEHOLDER': 'Saisissez vos idées',
    },
    'ACTIONS': {
      'SEARCH': {
        'PLACEHOLDER': 'Rechercher',
      }
    },
    'FOCUS_PROMPT': 'Questions de Discussion',
    'MOBILE_STATEMENTS': 'propos',
    'COLLECTED': 'Collecté',
    'FOCUS_PROMPT_TOOLTIP': 'Ces questions sont les propos de discussions de ce projet qui vous aident à générer des idées pour créer le contenu du projet. Les propos seront utilisées dans les autres activités du projet.',
    'HIDE_PROMPT': 'Cacher les questions',
    'DROPDOWN': {
      'SHOW_INTRODUCTION': 'Montrer l\'introduction',
      'SHOW_TOUR_AGAIN': 'Montrer le tour encore une fois',
      'LEAVE': 'Quitter le brainstorming',
      'FINISH': 'Terminer le brainstorming',
    },
    'MODAL': {
      'INTRODUCTION': {
        'BUTTON': 'COMMENCER',
      },
      'LIMIT': {
        'TITLE': 'Limite du brainstorming',
        'DESCRIPTION': 'Les limites des propos du projet sont atteintes. Vous ne pouvez pas en ajouter.',
        'BUTTON': 'FERMER',
      }
    },
    'PROJECT_HOME': 'Page d\'accueil du projet',
    'RETURN': 'Retourner au',
    'THANK_YOU': {
      'TITLE': 'Merci',
      'BUTTON': 'Retourner à la page d\'accueil du projet',
      'BUTTON_LINK': 'SUIVANT',
    },
    'TEXTAREA': {
      'PLACEHOLDER': 'Saisissez une idée de plus',
    },
    'CHARACTERS_LEFT': 'Nombre de caratères qui restent',
  },
  // === PARTICIPANT QUESTIONS ===
  // =============================
  'PARTICIPANT_QUESTIONS': {
    'TITLE': 'Questions des participants',
    'PAGE': 'Page',
    'OF': 'de',
    'FINISH': 'Terminer  ',
    'BACK': 'Précédent',
    'NEXT': 'Suivant',
    'DECIMALS_ALLOWED': 'Vous avez le droit d\'atteindre %0 de decimaux.',
    'RANGE': 'Min: %0  Max: %1',
    'DROPDOWN': {
      'SHOW_INTRODUCTION': 'Montrer l\'introduction',
      'LEAVE_QUESTIONS': 'Quitter les questions',
      'FINISH_QUESTIONS': 'Finir les questions',
    },
    'TEXTAREA_PLACEHOLDER': 'Saisissez votre réponse ici',
    'SELECT': 'Selectionner l\'option',
    'HOLD_MODAL': {
      'TITLE': 'Patientez',
      'DESCRIPTION': 'Vous devez compléter toutes les questions requises pour terminer cette activité.',
      'BUTTON': 'CONTINUER',
      'LEAVE_QUESTIONS_AND_RETURN_LATER': 'Quitter les questions et retourner plus tard',
    },
    'INTRODUCTION_MODAL': {
      'TITLE': 'Questions du participant',
      'BUTTON': 'COMMENCER',
    },
    'PROJECT_HOME': 'Page d\'accueil du projet',
    'RETURN': 'Retourner à  ',
    'THANK_YOU': {
      'TITLE': 'Merci',
      'BUTTON': 'Retourner à la page d\'accueil du projet',
      'BUTTON_LINK': 'SUIVANT',
    },
    'OOPS': {
      'TITLE': 'Oups!',
      'MESSAGE': 'Il n\'y a pas de questions de participant associé avec ce projet',
    },
    'OTHER': {
      'DEFAULT': 'Autre',
      'PLACEHOLDER': 'Saisissez votre réponse ici',
    },
    'CHARACTERS_LEFT': 'Caractères qui restent',
    'ERRORS': {
      'NUMERIC': 'La réponse de la question doit être entre les valeurs min et max et ne peuvent pas dépasser le nombre de décimaux indiqués.',
    },
    'REQUIRED_FIELD': '*indique les champs requis',
  },
  // ====== RATING ===========================
  // ==========================================
  'RATING': {
    'RATING': 'Évaluation',
    'SHOW_INTRO': 'Montrer l\'introduction',
    'LEAVE_QUESTION': 'Quitter les Questions',
    'FINISH_QUESTION': 'Terminer les Questions',
    'FOCUS_PROMPT': 'Questions de Discussion',
    'FINISH': 'Terminer',
    'OF': 'de',
    'STATEMENTS': 'Propos',
    'RATED': 'Évalué',
    'HIDE_PROMPT': 'Cacher le prompt',
    'IMPORTANCE': 'IMPORTANCE',
    'CHOOSE_RATING': 'Choisissez votre évaluation',
    'SELECT_RATING': 'SELECTIONNER L\'ÉVALUATION',
    'DECIMALS_ALLOWED': 'Jusqu\'à 2 décimaux authorisées.',
    'MIN': 'Min',
    'MAX': 'Max',
    'MODAL': {
      'INTRODUCTION': {
        'BUTTON': 'COMMENCER',
      },
      'FINISH': {
        'TITLE': 'Terminer l\'activité',
        'DESCRIPTION': 'L\'activité est déjà terminée',
        'ACTIONS': {
          'CONTINUE': 'CONTINUER',
          'LINK': 'Quitter le Triage et retourner plus tard',
        }
      }
    },
    'PROJECT_HOME': 'Page d\'accueil du projet',
    'RETURN': 'Retourner à',
    'THANK_YOU': {
      'TITLE': 'Merci',
      'BUTTON': 'RETOURNER À LA PAGE D\'ACCUEIL DU PROJET',
      'BUTTON_LINK': 'SUIVANT',
    },
    'STATEMENTS_LIST': {
      'PAGE': 'Page  ',
      'OF': 'de',
      'STATEMENTS': 'Propos',
      'TO': 'à',
      'ON': 'sur',
      'ON_PAGE': 'Sur cette page:',
      'ALL': 'Tout',
      'UNRATED': 'Pas évalué',
      'RATED': 'Évalué',
      'BACK': 'PRÉCÉDENT',
      'NEXT': 'SUIVANT',
    },
    'VALIDATION_ERROR': 'Cette évaluation doit être entre les valeurs min et max',
    'UNRATE': 'Pas évalué',
  },
  // ========== SORTING ==========
  // =============================
  'SORTING': {
    'TITLE': 'Triage',
    'CARDS': {
      'TITLE': 'Cartes',
      'MORE': 'Plus',
      'LESS': 'Moins',
      'ALL': 'Tout',
      'UNSORTED': 'Pas trié',
      'SORTED': 'Trié',
      'PILES': 'Piles',
      'SORT_IN': 'Trié dans',
      'IN_PILE': 'Dans la pile',
      'UNIQUE': 'Carte ',
      'MULTIPLE': 'Carte',
    },
    'INTRODUCTION': 'Glissez et déposez les cartes pour créer des piles',
    'OF': 'de',
    'STATEMENTS': 'Propos',
    'SORTED': 'Trié',
    'AUTO_SAVE': 'Modifications mises à jour',
    'FINISH': 'TERMINER',
    'EXPAND_ALL': 'Tout élargir',
    'COLLAPSE_ALL': 'Tout réduire',
    'DROPDOWN': {
      'SHOW_INTRODUCTION': 'Montrer l\'introduction',
      'SHOW_TOUR_AGAIN': 'Montrer le tour encore une fois',
      'LEAVE_SORTING': 'Quitter le triage    ',
      'FINISH_SORTING': 'Terminer le triage',
    },
    'MODAL': {
      'LANDSCAPE': {
        'MESSAGE': 'Pour une expérience optimale, mettez votre tablette sur le mode paysage',
      },
      'INTRODUCTION': {
        'BUTTON': 'COMMENCER',
      },
      'DELETE_PILE': {
        'TITLE': 'Suprimer la Pile',
        'DESCRIPTION': 'Êtes-vous sûr de vouloir supprimer la pile?',
        'BUTTONS': {
          'CANCEL': 'ANNULER',
          'YES': 'OUI',
        }
      },
      'FINISH': {
        'TITLE': 'Désolé',
        'DESCRIPTION': 'Vous devez avoir au moins %0 de cartes triées pour pouvoir terminer.',
        'ACTIONS': {
          'CONTINUE': 'CONTINUER',
          'LINK': 'Quitter le Triage et retourner plus tard',
        }
      },
      'SORT_IN': {
        'NEW_PILE': 'NOUVELLE PILE',
        'PLACEHOLDER': 'Saisissez votre nom',
        'NO_PILES': 'Aucune pile créé',
        'SORT': 'TRIER',
        'SEND': 'ENVOYER',
        'CARD': 'CARTE %0',
        'INTO': 'DANS',
        'TO_PILE': 'FAIRE UNE PILE ',
        'CREATE_NEW_PILE': 'Créer une nouvelle pile',
        'SAVE_NEW_PILE': 'Enregistrer',
        'CANCEL': '< Retourner aux propos',
        'SAVE': 'ENREGISTRER',
        'SUCCESS': 'Carte bien triée ',
        'NAMING': 'C\'est important de nommer les piles!',
        'ERROR_HELPER_PILE_NAME': 'Vous devez nommer cette pile',
      },
      'PILE': {
        'TITLE': 'PILE',
        'VIEW': 'Voir les cartes dans la pile',
        'EDIT': 'Modifier le nom de la pile',
        'DELETE': 'Supprimer la pile',
        'CANCEL': '< Retourner aux piles',
        'SAVE': 'ENREGISTRER',
        'CREATE': 'Créer une pile',
      }
    },
    'FOCUS_PROMPT': {
      'TITLE': 'QUESTIONS DE DISCUSSIONS:',
      'SUB_TITLE': 'Pour construire un bien-être national dans notre communité et pour notre peuple, nous devons...',
      'HIDE_PROMPT': 'Cacher le prompt',
    },
    'DROP': {
      'CREATE': 'Déposer pour créer',
      'NEW': 'nouvelle pile',
    },
    'DELETE_PILE': 'supprimer la pile',
    'DROP_TO_CREATE': 'Déposer pour créer',
    'NEW_PILE': 'nouvelle pile',
    'PILE_PLACEHOLDER': 'saisissez le nom de la pile',
    'PROJECT_HOME': 'Page d\'accueil du projet',
    'RETURN': 'Retourner à',
    'THANK_YOU': {
      'TITLE': 'Merci',
      'BUTTON': 'RETOURNER À LA PAGE D\'ACCUEIL DU PROJET',
      'BUTTON_LINK': 'SUIVANT',
    },
    'REVIEW': {
      'TITLE': 'Presque terminé!',
      'UNNAMED': 'Piles pas nommées',
      'ALL_NAMED': 'Toutes les piles ont été nommées',
      'ALL_NAMED_DESCRIPTION': 'Veuillez appuyer sur Terminé pour terminer l\'activité',
      'REVIEW': 'réviser',
      'DONE': 'Terminé',
      'FINISH': 'Terminer sans nommer',
      'BACK': 'Retourner au triage',
      'ACTIONS': {
        'OK': 'D\'accord',
        'TRY_USING': 'Essayez d\'utiliser',
        'OR': 'ou',
        'SWITCH': 'changer de pile',
      }
    },
    'PILES': {
      'NO_SORTED': 'Il n\'y a pas encore de propos trié dans les piles',
    }
  },
  'HELP_SUPPORT': {
    'TITLE': 'Aide & Assistance',
    'SUBTITLE': 'Comment pouvons-nous vous aider?',
    'CONTACT': {
      'TECHNICAL': 'Assistance Technique:',
      'SEND_MESSAGE': 'Envoyez nous un message',
      'GET_BACK': 'Nous vous réponderons dès que possible!',
      'PROJECT': 'PROJET',
      'EMAIL_PHONE': 'E-mail et numéro de téléphone de la personne à contacter',
      'OPTIONAL': 'facultatif',
      'TOPIC': 'THÈME',
      'ADDITIONAL_INFO': 'Information SUPPLÉMENTAIRES',
      'LET_US': 'Veuillez nous faire savoir quelle activité vous pose des problèmes. Donnez nous le plus d\'information possible.',
      'SUCCESS': 'Votre message a bien été envoyé.',
      'CONTACT_ERROR': 'Veuillez vérifier l\'e-mail ou le numéro de téléphone que vous avez saisi.',
    },
    'MODAL': {
      'TITLE': 'Ce message ne peut pas être envoyé.',
      'TEXT': 'Ce projet n\'a pas les coordonnées de la personne à contacter.',
      'CONTACT': 'Vous pouvez contacter l\'assistance technique ou envoyer un e-mail à assistance@conceptsystems.com.',
      'OK': 'D\'Accord',
    },
    'MOST_FREQUENT': 'Les questions les plus fréquemment posées',
    'PQ': 'Les questions des participants',
    'BS': 'Brainstorming',
    'TST': 'Triage des exercises de simulation',
    'DST': 'Triage de la liste déroulante',
    'RT': 'Questions d\'Évaluation',
    'CONTACT_US': 'Contactez-nous',
    'FOR': 'pour',
    'PLACEHOLDER': 'La Fondation Futur',
  },
  'FIRST_LOGIN': {
    'LINKS': {
      'PRIVACY': 'Confidentialité',
      'TERMS': 'Terme',
    }
  },
  'FORMS': {
    'PASSWORD_REQUIREMENTS': {
      'TITLE': 'Un mot de passe sécurisé doit comprendre au moins:',
    }
  },
  'LOCK': {
    'TITLE': 'Terminez toutes les questions d\'abord',
    'MESSAGE': 'Vous devez compléter toutes les questions requises avant de terminer l\'activité. Ou alors vous pouvez quitter et revenir plus tard.',
  },
  'BUBBLE': {
    'SKIP_INTRO': 'Ignorer l\'introduction',
    'BACK': 'Précédent',
    'NEXT': 'Suivant',
    'DONE': 'Terminé',
  }
};

export const LANG_FR_TRANS = Object.assign(LANG_FR, COUNTRIES_FR);



// WEBPACK FOOTER //
// ./src/app/translation/i18n/lang-fr.ts